<script>
    import {_} from '../lib/i18n';
    import {Constans} from "../lib/Constants";
    import {cancelSubscription} from "../lib/ApiRequests.svelte";
    import LoadingIcon from "./LoadingIcon.svelte";
    export let show = false;

    export let paidTill;
    export let params = {};

    function closeModal() {
        show = false;
    }

    export let showNextModal = false;

    let cancellationLoading = false;
    export let showSubscriptionSettings = true;
    async function initCancelSubscription() {
        if (cancellationLoading) return;

        cancellationLoading = true;
        const response = await cancelSubscription();
        if (response.status === 'ok') {
            try {
                if (params.changeSpySubscriptionStatus instanceof Function) {
                    params.changeSpySubscriptionStatus(Constans.spySubscriptionStatuses.CANCELED);
                }
            } catch (err) {
                console.error(err)
            }
            showSubscriptionSettings = false;
            closeModal();
        }
        cancellationLoading = false;
    }
</script>

<section class={`modal ${show ? '' : 'hide'}`}>
    <div class="modal__fade"></div>
    <div class="modal-body modal-body_subscription-cancel">
        <div on:click={closeModal} class="modal-body__close-icon" on:click={closeModal}>
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.06665 7.4668L15.5333 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M15.5333 7.4668L8.06666 14.9335" stroke="#C6C5D2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
        <div class="modal-body__header modal-body__header_кув">
            <div class="modal-body__header-icon">
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="21" cy="21" r="21" fill="#F2D2C0"/>
                    <ellipse cx="21.0007" cy="25.6665" rx="0.933333" ry="0.933333" fill="#C93329"/>
                    <path d="M21.001 19.1331L21.001 22.8664" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.1147 26.5054L19.212 14.3109C19.949 12.8368 22.0526 12.8368 22.7897 14.3109L28.8869 26.5054C29.5518 27.8352 28.5848 29.3998 27.0981 29.3998H14.9035C13.4168 29.3998 12.4498 27.8352 13.1147 26.5054Z" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <h4 class="modal-body__header-title">
                {$_('enCancelSubscriptionModal.title')}
            </h4>
        </div>
        <div class="modal-body__content-wrapper">
            <p class="modal-body__content-text">
                {@html $_('enCancelSubscriptionModal.description', {
                    values: { paidTill }
                })}
            </p>
        </div>
        <div class="modal-body__controls-wrapper">
            <button class="button button_shadow modal-body__btn-main" on:click={closeModal}>
                {$_('enCancelSubscriptionModal.yes')}
            </button>
            <button class="button button_textual modal-body__btn-secondary" on:click={initCancelSubscription}>
                <LoadingIcon show={cancellationLoading} height="16" width="16" />
                {$_('enCancelSubscriptionModal.no')}
            </button>
        </div>
    </div>
</section>

<style>
    .hide {
        display: none;
    }
    .modal-body__header-title {
        color: #C93329;
    }
    .modal-body__header-icon {
        background-color: #F2D2C0;
    }
</style>